import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTextItemHelperService } from '@fi-shared/fi-text-item-helper/fi-text-item-helper.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [FiTextItemHelperService],
})
export class FiTextItemHelperModule {}
